import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BUILD_PROFILE } from 'utils/buildProfile';
import { shouldDisableTracking } from 'utils/env';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: (...args: unknown[]) => void;
  }
}

const META_SCRIPT_ID = 'meta-pixel-script';

const MetaPixel = () => {
  const location = useLocation();
  const pixelId = (BUILD_PROFILE.metaPixelId || '').trim();
  const shouldEnable = !!pixelId && !shouldDisableTracking();

  useEffect(() => {
    if (!shouldEnable || typeof window === 'undefined' || typeof document === 'undefined') return;

    if (typeof window.fbq !== 'function') {
      const fbq = function (...args: unknown[]) {
        (fbq as any).callMethod
          ? (fbq as any).callMethod.apply(fbq, args)
          : (fbq as any).queue.push(args);
      };

      (fbq as any).push = fbq;
      (fbq as any).loaded = true;
      (fbq as any).version = '2.0';
      (fbq as any).queue = [];

      window.fbq = fbq;
      window._fbq = fbq;

      window.fbq('init', pixelId);
    }

    if (!document.getElementById(META_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = META_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
  }, [pixelId, shouldEnable]);

  useEffect(() => {
    if (!shouldEnable || typeof window === 'undefined' || typeof window.fbq !== 'function') return;

    window.fbq('track', 'PageView');
  }, [location.pathname, location.search, shouldEnable]);

  return null;
};

export default MetaPixel;
